var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "list-billing" } },
    [
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "div",
          { staticClass: "p-2 w-50" },
          [
            _c("vs-input", {
              staticClass: "mt-2 w-100",
              attrs: {
                "icon-after": "true",
                size: "small",
                "label-placeholder": "icon-after",
                icon: "mode_edit",
                placeholder: "Buscar coincidencias",
                "data-cy": "search"
              },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.fetchDocuments()
                }
              },
              model: {
                value: _vm.textSearch,
                callback: function($$v) {
                  _vm.textSearch = $$v
                },
                expression: "textSearch"
              }
            }),
            _vm.searchParam
              ? _c("vs-button", {
                  staticClass: "ml-3",
                  attrs: {
                    radius: "",
                    color: "primary",
                    type: "border",
                    icon: "highlight_off",
                    size: "small",
                    "data-cy": "search-clear"
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearSearch()
                    }
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "has-permission",
                rawName: "v-has-permission",
                value: "WBF101",
                expression: "'WBF101'"
              }
            ],
            staticClass: "ml-3 ml-auto"
          },
          [
            _c(
              "vs-button",
              {
                attrs: {
                  radius: "",
                  color: "primary",
                  flat: "",
                  "data-cy": "new-billing"
                },
                on: { click: _vm.onNewBilling }
              },
              [_vm._v(" Nueva Facturación ")]
            )
          ],
          1
        )
      ]),
      _c("BillingFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c("BillingHeader", {
        attrs: { exportable: true },
        on: { "export-list": _vm.exportList }
      }),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.list, function(file) {
          return _c("BillingRow", {
            key: file.febosId,
            attrs: {
              file: file,
              "select-file": _vm.selectFile,
              "data-cy": "file"
            }
          })
        }),
        1
      ),
      _c("PopUpBinnacleBilling"),
      _c("PopUpNewBilling"),
      _c(
        "vs-row",
        [
          _c("vs-col", { attrs: { "vs-lg": "3" } }, [
            _c("div", { staticClass: "mt-5" }, [
              _vm._v(" Mostrando "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.rowspp,
                      expression: "rowspp"
                    }
                  ],
                  on: {
                    change: [
                      function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.rowspp = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      function($event) {
                        return _vm.fetchDocuments()
                      }
                    ]
                  }
                },
                [
                  _c("option", { attrs: { value: "10" } }, [_vm._v("10 ")]),
                  _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                  _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                  _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
                ]
              ),
              _vm._v(" registros por página. ")
            ])
          ]),
          _c(
            "vs-col",
            { attrs: { "vs-lg": "9" } },
            [
              _c("BillingPagination", {
                model: {
                  value: _vm.page,
                  callback: function($$v) {
                    _vm.page = $$v
                  },
                  expression: "page"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }